import { Printer } from "@/interfaces";
import { http } from "../utils/http-common";

export function getPrinters(mode?: "list"): Promise<Printer[]> {
  return http.get("/printers", { params: mode ? { mode } : undefined }).then((res) => {
    return res.data.data;
  });
}
export function getPrintersById(id: string) {
  return http.get(`/printers/${id}`).then((res) => {
    return res.data;
  });
}

export function updatePrinter(printerId: number, data: Printer) {
  return http.put(`/printers/${printerId}`, data).then((res) => {
    return res.data.data;
  });
}

export async function deletePrintersBulk(printerIds: number[]) {
  return http.delete(`/printers/bulk`, { params: { ids: printerIds.join(",") } }).then((res) => {
    return res.data;
  });
}

export async function pausePrinter(printerId: number) {
  return http.post(`/printers/${printerId}/pause-queue`).then((res) => {
    return res.data;
  });
}

export async function resumePrinter(printerId: number) {
  return http.post(`/printers/${printerId}/start-queue`).then((res) => {
    return res.data;
  });
}

export async function requestPrinterInfo(printerId: number): Promise<Printer> {
  return http.post(`/printers/${printerId}/printer-info`).then((res) => {
    return res.data.data;
  });
}
export async function printerHasControlCenterConnection(printerId: number): Promise<boolean> {
  try {
    const res = await http.get(`/printers/${printerId}/agent-connection`);
    return res.data === true || res.data === "true";
  } catch {
    return false;
  }
}
